<script>
export default {
  props: {
    direction: {
      type: String, //row or column
      default: "row"
    },
    align: {
      type: String, //start, end or center
      default: "center"
    },
    justify: {
      type: String, //start, end or center
      default: "center"
    },
    wrap: {
      type: Boolean,
      default: true
    }
  }
};
</script>

<template>
  <div :direction="direction" :align="align" :justify="justify" :wrap="wrap">
    <slot></slot>
  </div>
</template>

<style lang="scss" scoped>
div {
  display: flex;

  &[direction="row"] {
    flex-direction: row;
  }
  &[direction="column"] {
    flex-direction: column;
  }

  @each $key, $direction in $flex-directions {
    &[align="#{$key}"] {
      align-items: $direction;
    }
    &[justify="#{$key}"] {
      justify-content: $direction;
    }
  }

  &[wrap="true"] {
    flex-wrap: wrap;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/_base/Flex.vue